import FormTemplate from "./FormTemplate.vue"
import InputBox from "./FormElements/Fields/InputBox.vue"
import TextArea from "./FormElements/Fields/TextArea.vue"
import RadioButton from "./FormElements/Fields/RadioButton.vue"
import SwitchButtonGroup from "./FormElements/Fields/SwitchButtonGroup.vue"
import SwitchButton from "./FormElements/Fields/SwitchButton.vue"
import InfoField from "./FormElements/Fields/InfoField.vue"

const COMPONENT_MAP = {
  formTemplate: FormTemplate,
  text: InputBox,
  textarea: TextArea,
  radio: RadioButton,
  switchgroup: SwitchButtonGroup,
  switch: SwitchButton,
  info: InfoField
}

export function getComponent(type) {
  return COMPONENT_MAP[type]
}
